import React, { useState } from "react";
import { isInIframe, postMessageToWorkbench } from "@/utils";
import styles from "./index.module.css";

const RenderErrorFallback = ({ error }: { error: Error }) => {
  const [showErrorStark, setShowErrorStark] = useState(false);

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorMessage}>
        <strong>React 页面渲染异常，请联系页面开发者检查代码逻辑</strong>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setShowErrorStark(!showErrorStark);
          }}
        >
          [查看完整错误堆栈]
        </button>
        {/* 如果在web-app工程下嵌入使用, 可以使用一键修复功能, 通过postMessage将错误信息抛出, 由工作台应用处理 */}
        {isInIframe() && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              postMessageToWorkbench({
                action: "reactPageRenderError",
                data: error,
              });
            }}
          >
            [AI一键修复]
          </button>
        )}
      </div>
      <div className={styles.errorStark}>
        {showErrorStark ? (
          <pre>
            <code>{error.stack}</code>
          </pre>
        ) : (
          <code>
            {error?.name}: {error?.message || "未知"}
          </code>
        )}
      </div>
    </div>
  );
};

export default RenderErrorFallback;
